import { render, staticRenderFns } from "./datasubject-transfer-minimization-status.vue?vue&type=template&id=46508196&scoped=true"
import script from "./datasubject-transfer-minimization-status.vue?vue&type=script&lang=js"
export * from "./datasubject-transfer-minimization-status.vue?vue&type=script&lang=js"
import style0 from "./datasubject-transfer-minimization-status.vue?vue&type=style&index=0&id=46508196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46508196",
  null
  
)

export default component.exports